import Badge from '@mui/material/Badge'
import SvgIcon from '@mui/material/SvgIcon'
import Tooltip from '@mui/material/Tooltip'
import {
    FilterPanelTrigger, ToolbarButton,
} from '@mui/x-data-grid-pro'
import useStyles
    from 'app/PoC/DataGridDemoPages/components/SkyBaseDataGrid/components/SkyBaseDataGridToolbar/SkyBaseFilterButton/SkyBaseFilterButton.styles'
import useActiveFiltersCount from 'app/PoC/DataGridDemoPages/components/SkyBaseDataGrid/hooks/useActiveFiltersCount'

const DefaultFilterIcon = () => {
    return (
        <SvgIcon
            viewBox="0 0 17 15"
            sx={{
                width: 17,
                height: 17,
            }}
        >
            <path
                d="M7.99996 16C7.71662 16 7.47913 15.9042 7.28746 15.7125C7.09579 15.5208 6.99996 15.2833 6.99996 15V9L1.19996 1.6C0.949958 1.26667 0.912458 0.916667 1.08746 0.55C1.26246 0.183333 1.56662 0 1.99996 0H16C16.4333 0 16.7375 0.183333 16.9125 0.55C17.0875 0.916667 17.05 1.26667 16.8 1.6L11 9V15C11 15.2833 10.9041 15.5208 10.7125 15.7125C10.5208 15.9042 10.2833 16 9.99996 16H7.99996Z"
            />
        </SvgIcon>
    )
}

export default function SkyBaseFilterButton({
    filterIcon: FilterIcon = DefaultFilterIcon,
}: Readonly<{
    filterIcon?: (props: {
        className?: string
    }) => JSX.Element
}>) {
    const {
        classes,
    } = useStyles()
    const activeFiltersCount = useActiveFiltersCount(true)

    return (
        <Tooltip title="Filters">
            <FilterPanelTrigger
                render={(props) => {
                    return (
                        <ToolbarButton
                            {...props} /* eslint-disable-line react/jsx-props-no-spreading */
                            color="default"
                            data-testid="filter-btn"
                        >
                            <Badge
                                badgeContent={activeFiltersCount}
                                color="primary"
                                variant="dot"
                            >
                                <FilterIcon
                                    className={classes.filterIcon}
                                />
                            </Badge>
                        </ToolbarButton>
                    )
                }}
            />
        </Tooltip>
    )
}
